import { theme } from '../../theme/theme';

export const styles = {
  open: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.open,
    fontWeight: 600,
  },
  published: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.published,
    fontWeight: 600,
    color: theme.palette.primary.white,
  },
  draft: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.draft,
    fontWeight: 600,
    color: theme.palette.primary.white,
  },
  closed: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.closed,
    fontWeight: 600,
  },
  archived: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.archived,
    color: theme.palette.primary.white,
    fontWeight: 600,
  },
  frozen: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.frozen,
    color: theme.palette.primary.white,
    fontWeight: 600,
  },
  type: {
    textTransform: 'capitalize',
    fontWeight: 600,
  },
  button: {
    fontWeight: '600',
    textTransform: 'none',
    marginBottom: '5px',
    marginLeft: '10px',
  },
  icon: {
    fontSize: '14px !important',
  },
  noResultHeading: {
    fontSize: 17,
    margin: 15,
    fontWeight: 500,
  },
  clearButton: {
    fontWeight: '600',
    textTransform: 'none',
    backgroundColor: theme.palette.open,
    minWidth: 'fit-content',
  },
  filterContainer: {
    float: 'right',
    display: 'flex',
    padding: '0 0 0 30px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  clickableHeader: {
    cursor: 'pointer',
    position: 'relative',
    bottom: '3px',
    whiteSpace: 'nowrap',
  },
  downArrowStyles: {
    position: 'relative',
    // top: '7px',
  },
  upArrowStyles: {
    position: 'relative',
    // top: '7px',
  },
};
